import httpService from './httpService';

const getAll = () => httpService.get('/api/education/all');

export default { getAll };
